import { useEffect, useRef, useState } from "react";

import moment from "moment";
import { useModalForm } from "../../../../utils/hooks/useModalForm";
import MainPagetitle from "../../../layouts/MainPagetitle";
import OfflineModal from "../OfflineLeads/OfflineModal";
import SendPayoutModal from "../OfflineLeads/SendPayoutModal";
import EnquiryCards from "./EnquiryCards";
import EnquirySearch from "./EnquirySearch/EnquirySearch";

const Enquiries = (props) => {
  const isPanVerified = props.$store?.user?.is_pan_code_verified;
  const isAadharVerified = props.$store?.user?.is_aadhar_verified;
  const is_agreement_signed = props.$store?.user?.is_agreement_signed;

  const payoutModalRef = useRef(0);
  const [search, setSearch] = useState({
    page: 1,
    limit: 10,
  });
  const [totalPageChange, setTotalPageChange] = useState({
    page: 1,
    limit: 10,
    // order_by: "updatedAt",
    // order_direction: "DESC",
  });
  const adminPersona = props?.$store?.user?.role === _enum.ROUTE_PERSONAS.admin;
  const [tableData, setTableData] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [routeName, setRouteName] = useState("");
  const [cardData, setCardData] = useState();
  const [errorMessage, setErrorMessage] = useState({ name: "", message: "" });
  const [modalFields, setModalFields] = useState([
    {
      name: "leadName",
      label: "Customer Name",
      type: "text",
      placeholder: "Please enter",
      required: true,
      onChange: (value) => handleCustName(value),
    },
    {
      name: "borrower_mobile_number",
      label: "Mobile No.",
      type: "text",
      placeholder: "Please enter",
      required: true,
      onChange: (value) => handleMobileNo(value),
    },
    {
      name: "productType",
      label: "Product Type",
      type: "select",
      options: [],
      placeholder: "Please enter",
      // outerclass: "readonly_field",
      required: true,
    },
    {
      name: "bankName",
      label: "Bank Name",
      type: "select",
      options: [],
      placeholder: "Please enter",
      required: true,
    },
    {
      name: "loanAmount",
      label: "Loan Amount",
      type: "text",
      placeholder: "Please enter",
      required: true,
      onChange: (value) => handleLoanAmount(value),
    },
    {
      name: "applicationNumber",
      label: "Application No.",
      type: "text",
      required: true,
      placeholder: "Please enter",
    },
    {
      name: "applicationDate",
      label: "Application Date",
      type: "date",
      disabledDate: (current) => {
        return current && current > moment().endOf("day");
      },
      placeholder: "Please enter",
      required: true,
    },
    {
      name: "status",
      label: "Application Status",
      type: "select",
      options: _enum.LOAN_STATUS_NEW,
      placeholder: "Please select",
      required: true,
      onChange: (value) => handleApplicationStatus(value),
    },
    {
      name: "disbursementAmount",
      label: "Disb. Amount",
      type: "text",
      placeholder: "Please enter",
      onChange: (value) => handleDisbAmount(value),
      required: true,
      // outerclass: "d-none",
    },
    {
      name: "disbursementDate",
      label: "Disb. Date",
      type: "date",
      disabledDate: (current) => {
        return current && current < moment().startOf("day");
      },
      placeholder: "Please enter",
      required: true,
      // outerclass: "d-none",
    },
  ]);
  const [editData, setEditData] = useState({});
  const [editmode, setEditmode] = useState(false);
  const [viewmode, setViewmode] = useState(false);
  const [openCanvas, setOpenCanvas] = useState(false);
  const [popupfields, setPopupfields] = useState({});
  const [popupdata, setPopupdata] = useState({});
  const [leadId, setLeadId] = useState("");

  const [rowcount, setRowcount] = useState(0);
  const columns = [
    {
      dataIndex: "borrower_first_name",
      title: "Name",
      render: (text, record) => {
        let fullname = `${record?.borrower_first_name} ${record?.borrower_last_name}`;
        return <span className="table-primary-text">{fullname}</span>;
      },
    },
    {
      dataIndex: "borrower_mobile_number",
      title: "Mobile No.",
    },
    {
      dataIndex: "application_product_type",
      title: "Product Type",
      render: (text) => {
        return <>{text?.toTitleCase() || "-"}</>;
      },
    },
    {
      dataIndex: "loan_applied_amount",
      title: "Loan Amount",
      render: (text) => {
        return <>{text?.cur(0)}</>;
      },
    },
    {
      dataIndex: "disbursementAmount",
      title: "Disb. Amt.",
      render: (text, record) => {
        return <>{record?.application?.loan_disbursed_amount?.cur(0) || "-"}</>;
      },
    },
    {
      dataIndex: "disbursementDate",
      title: "Disb. Date",
      render: (text, record) => {
        let dateStr = record?.application?.loan_disbursement_date || null;
        if (dateStr) {
          let date = new Date(dateStr).dateToDDMMYYYY(new Date(dateStr));
          return date;
        } else {
          return "-";
        }
      },
    },
    {
      dataIndex: "status",
      title: "Application Status",
      render: (text, record) => {
        let status = record?.application?.application_status;
        return (
          <AppTag color={_enum.STATUS_COLOR_MAP[status?.toLowerCase()]}>
            {status?.toTitleCase() || "-"}
          </AppTag>
        );
      },
    },
  ];

  const [payoutPopupfields, setPayoutPopupfields] = useState({});
  const [payoutdata, setPayoutdata] = useState({});
  const [payoutfields, setPayoutfields] = useState([
    {
      name: "payoutType",
      label: "Confirm payout type",
      type: "select",
      options: _enum.PAYOUT_TYPES,
      placeholder: "select any",
      customcolspan: "12",
      required: true,
    },
  ]);

  const toastConfig = {
    autoClose: 3000,
    closeButton: false,
    hideProgressBar: true,
  };
  // ROW SELECTION
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [assignDept, setAssignDept] = useState({});
  const [notSelected, setNotSelected] = useState(true);

  const onPageChange = (pageData) => {
    setTotalPageChange({
      ...search,
      page: pageData.current,
      limit: pageData.pageSize || pageData.defaultPageSize || 25,
    });
  };

  // const openModal = () => {
  //   setOpenCanvas(true);
  // };

  // const closeModal = () => {
  //   setOpenCanvas(false);
  // };

  const handleCustName = (e) => {
    const stringReg = _enum?.REGEX?.onlystring;
    if (stringReg.test(e.target.value)) setErrorMessage("");
    else
      setErrorMessage({
        name: "leadName",
        message: "Special characters are not allowed",
      });
  };
  const handleMobileNo = (e) => {
    const numberReg = _enum?.REGEX?.number;
    const fieldValue = e.target.value;
    if (numberReg.test(fieldValue) && fieldValue.length === 10)
      setErrorMessage("");
    else
      setErrorMessage({
        name: "mobileNumber",
        message: "Please enter a valid Mobile Number",
      });
  };
  const handleLoanAmount = (e) => {
    const numberReg = _enum?.REGEX?.number;
    const fieldValue = e.target.value;
    if (numberReg.test(fieldValue)) setErrorMessage("");
    else
      setErrorMessage({
        name: "loanAmount",
        message: "Please enter a valid Loan Amount",
      });
  };
  const handleDisbAmount = (e) => {
    const numberReg = _enum?.REGEX?.number;
    const fieldValue = e.target.value;
    if (numberReg.test(fieldValue)) setErrorMessage("");
    else
      setErrorMessage({
        name: "disbursementAmount",
        message: "Please enter a valid Disbursement Amount",
      });
  };

  const getConnectorLeads = (params = {}, reset) => {
    let payload = {};
    if (reset) {
      let defaultSearchData = Object.only(search, [
        "limit",
        "page",
        // "order_by",
        // "order_direction",
      ]);

      setSearch(defaultSearchData);
      payload = {
        ...defaultSearchData,
        ...params,
      };
      // console.log({ defaultSearchData: payload });
    } else {
      payload = {
        ...search,
        ...params,
      };
    }
    props.apis
      .apiGetAllConnectorLeads({
        ...payload,
        application_status: ["OPEN", "APPLIED", "DISBURSED"],
      })
      .then(({ data, total }) => {
        console.log({ apiGetAllConnectorLeads: data });
        setTableData(data);
        setIsFetching(false);
        setRowcount(total);
      })
      .catch((err) => console.error(err));
  };

  const viewConnectorLead = (record) => {
    setEditmode(false);
    setViewmode(true);
    // GET CONNECTOR LEAD BY ID
    getConnectorLead(record, "view");
  };

  const editConnectorLead = (record) => {
    if (record?.isEnabled === false) {
      swal2.fire({
        title: "Disbursed leads cannot be edited",
        icon: "error",
        iconColor: "#FF4D4D",
        timer: 4000,
      });
    } else {
      setEditmode(true);
      setViewmode(false);
      setLeadId(record.leadId);
      getConnectorLead(record, "edit");
    }
  };

  const getConnectorLead = (record, mode) => {
    let urlData = {
      connector_lead_id: record.connector_lead_id,
    };
    // GET CONNECTOR LEAD BY ID
    props.apis.apiGetConnectorLeadById(urlData).then((res) => {
      console.log({ apiGetConnectorLeadById: res });

      let filteredData = {
        borrower_first_name: res?.borrower_first_name,
        borrower_last_name: res?.borrower_last_name,
        borrower_mobile_number: res?.borrower_mobile_number,
        application_product_type: res?.application_product_type,
        application_sub_product_type: res?.application_sub_product_type,
        loan_applied_amount: Number(res?.loan_applied_amount),
        property_details: res?.property_details,
        loan_property_finalized: res?.loan_property_finalized,
        loan_property_address: res?.loan_property_address,
        loan_property_value: res?.loan_property_value,
        application_status: res?.application?.application_status,
        application_number: res?.application?.application_number,
        loan_application_date: res?.loan_application_date,
        loan_disbursed_amount: Number(res?.application?.loan_disbursed_amount),
        loan_disbursement_date: res?.application?.loan_disbursement_date,
      };

      setEditData(res);
      openModal(
        "leadFields",
        mode,
        `${mode?.toTitleCase()} Lead`,
        filteredData
      );
    });
  };

  const deleteConnectorLead = (record) => {
    console.log({ record });
    // DELETE OFFLINE LEADS BY LEADS
    if (record?.status === _enum.LOAN_STATUS_MAP.disbursed) {
      swal2.fire({
        title: "Disbursed leads cannot be deleted",
        icon: "error",
        iconColor: "#FF4D4D",
        timer: 4000,
      });
    } else {
      swal2
        .fire({
          title: "Are you sure you want to delete this application?",
          width: 500,
          icon: "warning",
          iconColor: "#234C9B",
          showCancelButton: true,
          confirmButtonColor: "#234C9B",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        })
        .then((result) => {
          if (result.isConfirmed) {
            props.apis
              .apiDeleteOfflineLeads({
                leadId: record.leadId,
              })
              .then((res) => {
                console.log({ apiDeleteOfflineLeads: res });
                swal2.fire({
                  title: "Applicant deleted successfully !!",
                  icon: "success",
                  iconColor: "#234C9B",
                  timer: 4000,
                });
                getConnectorLeads();
              });
          }
        });
    }
  };

  const handleSubmit = (e, data, form) => {
    e.preventDefault();
    console.log("formdata: ", data);
    let formdata = data;
    let cansubmit = true;
    let addPayload = {
      ...Object.except(formdata, [
        "loanAmount",
        "productType",
        "applicationDate",
      ]),
    };

    addPayload.loanAmount = Number(formdata.loanAmount);
    addPayload.productType = String(formdata.productType);
    console.log({ addPayload });
    if (addPayload.disbursementAmount) {
      addPayload.disbursementAmount = Number(formdata.disbursementAmount);
    }
    if (addPayload.disbursementDate) {
      addPayload.disbursementDate = new Date(
        formdata.disbursementDate
      ).toISOString();
    }
    if (formdata?.applicationDate) {
      addPayload.applicationDate = new Date(
        formdata?.applicationDate
      ).toISOString();
    } else {
      cansubmit = false;
      toast.error("Required fields cannot be empty", toastConfig);
    }

    if (data.status !== _enum?.LOAN_STATUS_MAP?.disbursed) {
      addPayload.disbursementAmount = null;
      addPayload.disbursementDate = null;
    } else if (
      (data.status === _enum?.LOAN_STATUS_MAP?.disbursed &&
        addPayload.disbursementAmount === "") ||
      addPayload.disbursementDate === ""
    ) {
      cansubmit = false;
      toast.error("Required fields cannot be empty", toastConfig);
    } else {
      addPayload.disbursementAmount = Number(formdata.disbursementAmount);
      addPayload.disbursementDate = new Date(
        formdata.disbursementDate
      ).toISOString();
      cansubmit = true;
    }

    console.log({ addPayload, cansubmit });
    if (cansubmit) {
      if (editmode) {
        props.apis
          .apiUpdateApplication(addPayload, {
            applicationLeadId: editData?.applicationLeadId,
          })
          .then((response) => {
            console.log({ apiUpdateApplication: response });
            let filteredData = Object.only(
              response,
              modalFields.map((v) => v.name)
            );
            console.log({ filteredData });
            setPopupdata(filteredData);
            setEditData(response.data);
            closeModal();
            swal2.fire({
              title: "Lead updated successfully !!",
              icon: "success",
              iconColor: "#234C9B",
              timer: 4000,
            });
            getConnectorLeads();
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        props.apis
          .apiAddApplication(
            {
              profileId: props?.$store?.user?.profileId,
            },
            Object.removeEmptyProps(addPayload)
          )
          .then((res) => {
            console.log({ apiAddOfflineLeads: res });
            closeModal();
            getConnectorLeads();
            swal2.fire({
              title: "Lead added successfully",
              icon: "success",
              iconColor: "#234C9B",
              timer: 4000,
            });
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  };

  const onSearch = (data, reset) => {
    console.log("onSearch on leads", data, reset);
    if (Object.keys(data).length === 0) {
      setSearch({
        ...data,
        ...search,
      });
      getConnectorLeads();
    } else {
      setSearch({
        ...search,
      });
      getConnectorLeads(data, reset);
    }
  };

  const addModalFields = (values) => {
    setEditmode(false);
    setViewmode(false);

    let fields = (modalFields || []).reduce(
      (o, n) => ({ ...o, [n.name]: n }),
      {}
    );
    let formdata = Object.map(fields, (v, k) => "");
    // console.log("formdata: ", fields, formdata);

    setPopupfields(fields);
    setPopupdata(formdata);
    setOpenCanvas(true);
  };

  const onModalClose = () => {
    setPopupfields({});
    setViewmode(false);
    setEditmode(false);
    setEditData({});
    closeModal();
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => {
      if (
        record?.application?.application_status ===
        _enum?.LOAN_STATUS_MAP?.disbursed
      ) {
        return {
          disabled: false,
        };
      } else {
        return {
          disabled: true,
        };
      }
    },
  };

  const handleSendPayout = () => {
    // hiding payout modal temporary, might enable later
    // openPayoutModal();
    let payload = {
      connector_lead_ids: [...selectedRowKeys.map((v) => v)],
    };
    console.log({ handleSendPayout: payload });
    props.apis.apiSendConnectorLeadsForPayout(payload).then((res) => {
      console.log({ apiSendConnectorLeadsForPayout: res });
      if (res) {
        swal2.fire({
          title: "Leads send for payout successfully",
          icon: "success",
          iconColor: "#234C9B",
          timer: 4000,
        });
        setSelectedRowKeys([]);
        // closePayoutModal();
        getConnectorLeads();
      }
    });
  };

  // ----------------------------------------------------------------
  // HANDLE CHANGE PASSWORD MODAL
  const openPayoutModal = () => {
    payoutModalRef.current.click();
  };

  const closePayoutModal = () => {
    document.querySelector("#sendPayoutModal #bsmodalclose").click();
    setPayoutdata({});
    setPayoutPopupfields({});
  };

  const addChangepasswordData = () => {
    let fields = (payoutfields || []).reduce(
      (o, n) => ({ ...o, [n.name]: n }),
      {}
    );
    let formdata = Object.map(fields, (v, k) => "");
    // console.log("formdata: ", fields, formdata);
    setPayoutdata(formdata);
    setPayoutPopupfields(fields);
    openPayoutModal();
  };

  const getBankNames = () => {
    let payload = {
      page: 1,
    };
    props.apis.apiGetBanknames(payload).then((data) => {
      setBankNames(data);
      // let bankNameField = modalFields.find((o) => o.name === "bankName");
      // bankNameField.options = data;
      // setModalFields([...modalFields]);
    });
  };

  const getProductTypes = () => {
    props.apis.apiGetProductTypes().then((res) => {
      setProductTypes(res);
      // let productType = modalFields.find((o) => o.name == "productType");
      // productType.options = res;
      // setModalFields([...modalFields]);
    });
  };

  const handlePayoutSubmit = (e, data) => {
    let payload = {
      leadIds: [...selectedRowKeys],
      payoutType: data?.payoutType,
      leadCategory: "OFFLINE",
    };
    console.log({ handlePayoutSubmit: payload });
    props.apis.apiSendConnectorLeadsForPayment(payload).then((res) => {
      console.log({ apiSendConnectorLeadsForPayment: res });
      if (res) {
        swal2.fire({
          title: "leads send for payment successfully",
          icon: "success",
          iconColor: "#234C9B",
          timer: 4000,
        });
        setSelectedRowKeys([]);
        closePayoutModal();
        getConnectorLeads();
      }
    });
  };

  const getLeadsDashboardInfo = () => {
    // props.apis.apiGetLeadsDashboardInfo().then((res) => {
    //   console.log({ res });
    //   setCardData(res);
    // });
    setCardData(null);
  };

  // ------------------------------------------------------------------
  const [productTypes, setProductTypes] = useState(null);
  const [bankNames, setBankNames] = useState(null);
  // CONNECTOR LEAD LOAN
  const modalConfigs = {
    leadFields: [
      {
        type: "section",
        label: "Customer Details",
        divider: false,
        colspan: 24,
        align: "end",
      },
      {
        name: "borrower_first_name",
        label: "First Name",
        type: "text",
        placeholder: "Please enter",
        required: true,
        rules: _enum.ONLY_STRING_RULE,
      },
      {
        name: "borrower_last_name",
        label: "Last Name",
        type: "text",
        placeholder: "Please enter",
        required: true,
        rules: _enum.ONLY_STRING_RULE,
      },
      {
        name: "borrower_mobile_number",
        label: "Mobile No.",
        type: "text",
        placeholder: "Please enter",
        rules: _enum.MOBILE_NUM_RULE,
        required: true,
      },
      {
        type: "section",
        label: "Loan Details ",
        divider: true,
        colspan: 24,
        align: "end",
      },
      { type: "empty", colspan: 24 },
      {
        name: "application_product_type",
        label: "Loan Type",
        type: "select",
        options: _enum.APPLICATION_PRODUCT_TYPE,
        // fetchKey: "PRODUCTS",
        // fetchOptions: () => props.apis.apiGetProductTypes(),
        placeholder: "Please enter",
        required: true,
      },
      {
        name: "application_sub_product_type",
        label: "Loan Sub Type",
        type: "select",
        options: _enum.APPLICATION_SUB_PRODUCT_TYPE,
        // fetchKey: "PRODUCTS",
        // fetchOptions: () => props.apis.apiGetProductTypes(),
        placeholder: "Please enter",
        required: true,
      },
      {
        name: "loan_applied_amount",
        label: "Loan Amount",
        type: "text",
        placeholder: "Please enter",
        required: true,
        // onChange: (value) => handleLoanAmount(value),
      },
      {
        name: "property_details",
        label: "Property Details",
        type: "text",
        placeholder: "Please enter",
        required: true,
      },
      {
        name: "loan_property_finalized",
        label: "Has Customer Finalized Property ?",
        type: "select",
        options: _enum.YES_OR_NO,
        placeholder: "Please enter",
        required: true,
      },
      {
        name: "loan_property_address",
        label: "Property Address",
        type: "text",
        placeholder: "Please enter",
      },
      {
        name: "loan_property_value",
        label: "Property Value",
        type: "text",
        placeholder: "Please enter",
      },
      {
        name: "application_status",
        label: "Application Status",
        type: "select",
        options: _enum.APPLICATION_STATUS,
        placeholder: "Please select",
        required: true,
      },
      {
        name: "application_number",
        label: "Application No.",
        type: "text",
        required: true,
        placeholder: "Please enter",
      },
      {
        name: "loan_application_date",
        label: "Application Date",
        type: "date",
        disabledDate: (current) => {
          return current && current > moment().endOf("day");
        },
        placeholder: "Please enter",
        required: true,
      },
      {
        name: "loan_disbursed_amount",
        label: "Disb. Amount",
        type: "text",
        placeholder: "Please enter",
        showWhen: (values) => values.application_status === "DISBURSED",
        required: true,
      },
      {
        name: "loan_disbursement_date",
        label: "Disb. Date",
        type: "date",
        disabledDate: (current) => {
          return current && current < moment().startOf("day");
        },
        placeholder: "Please enter",
        showWhen: (values) => values.application_status === "DISBURSED",
        required: true,
      },
    ],
  };
  const dependencies = {};
  const [applId, setApplId] = useState(null);

  const {
    appform,
    state: modalState,
    openModal,
    closeModal,
    handleValuesChange,
  } = useModalForm(modalConfigs, dependencies);

  const openApplicationModal = () => {
    let defaultValues = {};

    openModal("leadFields", "add", "Add Lead", defaultValues);
    console.log(modalConfigs.leadFields);
  };

  const handleAppModalSubmit = async (data) => {
    // console.log({ modalState, data });

    let payload = {
      borrower_first_name: data?.borrower_first_name,
      borrower_last_name: data?.borrower_last_name,
      borrower_mobile_number: data?.borrower_mobile_number,
      application_product_type: data?.application_product_type,
      application_sub_product_type: data?.application_sub_product_type,
      loan_applied_amount: Number(data?.loan_applied_amount),
      property_details: data?.property_details,
      loan_property_finalized: data?.loan_property_finalized,
      loan_property_address: data?.loan_property_address,
      loan_property_value: data?.loan_property_value,
      application_status: data?.application_status,
      application_number: data?.application_number,
      loan_application_date: data?.loan_application_date,
      loan_disbursed_amount: Number(data?.loan_disbursed_amount),
      loan_disbursement_date: data?.loan_disbursement_date,
    };

    console.log({ payload });

    if (modalState.mode === "edit") {
      props.apis
        .apiUpdateConnectorLeadById(payload, {
          connector_lead_id: editData?.connector_lead_id,
        })
        .then((res) => {
          console.log({ apiUpdateConnectorLeadById: res });

          if (res) {
            swal2.fire({
              title: "Leads updated successfully.",
              icon: "success",
              iconColor: "#234C9B",
              confirmButtonText: "Ok",
              timer: 4000,
            });

            closeModal(); // close only after success
            getConnectorLeads();
          }
        })
        .catch((err) => console.error(err));
    } else if (modalState.mode === "add") {
      props.apis
        .apiAddConnectorLead(payload)
        .then((res) => {
          console.log({ apiAddConnectorLead: res });

          if (res) {
            swal2.fire({
              title: "Leads added successfully.",
              icon: "success",
              iconColor: "#234C9B",
              confirmButtonText: "Ok",
              timer: 4000,
            });

            closeModal(); // close only after success
            getConnectorLeads();
          }
        })
        .catch((err) => console.error(err));
    }
  };
  // ------------------------------------------------------------------

  const getBackLink = () => {
    return "/app/enquiries";
  };

  useEffect(() => {
    selectedRowKeys.length > 0 ? setNotSelected(false) : setNotSelected(true);
  }, [selectedRowKeys]);

  useEffect(() => {
    let fields = (modalFields || []).reduce(
      (o, n) => ({ ...o, [n.name]: n }),
      {}
    );
    setPopupfields(fields);
  }, [editData]);

  // useEffect(() => {
  //   getBankNames();
  //   getProductTypes();
  //   console.log({ editmode, viewmode });

  //   if (editmode === false && viewmode === false) {
  //     // let rname = props?.urlparams?.params?.leadname;
  //     // console.log(rname);
  //     // setRouteName(rname);
  //     // let productType = modalFields.find((o) => o.name == "productType");
  //     // productType.defaultValue = rname;
  //     // // productType.readOnly = true;
  //     // setModalFields([...modalFields]);
  //   } else {
  //     // let productType = modalFields.find((o) => o.name == "productType");
  //     // productType.defaultValue = editData?.productType;
  //     // setModalFields([...modalFields]);

  //     setTimeout(() => {
  //       if (editData?.status !== "DISBURSED") {
  //         document
  //           .querySelector('[name="disbursementAmount"]')
  //           .removeAttribute("required");
  //         document
  //           .querySelector('[name="disbursementDate"]')
  //           .removeAttribute("required");
  //       }
  //     }, 100);
  //     console.log("not add modal");
  //   }
  // }, [openCanvas]);

  useEffect(() => {
    getLeadsDashboardInfo();
    getBankNames();
    // getProductTypes();

    if (!isPanVerified || !isAadharVerified || !is_agreement_signed) {
      swal2
        .fire({
          title: "Account Verification Pending",
          text: "Please complete your profile",
          icon: "info",
          iconColor: "#234C9B",
        })
        .then((result) => {
          if (result.isConfirmed) {
            props.navigate("/app/myprofile");
          }
        });
    }
  }, []);

  useEffect(() => {
    getConnectorLeads(totalPageChange);
  }, [totalPageChange]);

  props.$setNode({
    props,
    search,
    editData,
  });
  return (
    <>
      <MainPagetitle
        mainTitle="My Leads"
        backLink={getBackLink()}
        pageIcon={imagepaths.ProfileActive}
      />
      {isPanVerified && isAadharVerified && is_agreement_signed ? (
        <div className="container-fluid pb-5 px-lg-5">
          <div className="row">
            <div className="col-xl-12">
              {/* <EnquiryCards /> */}

              <div className="card h-auto">
                <div className="card-body p-0">
                  <div className="tbl-caption-container justify-content-end">
                    <EnquirySearch
                      onSearch={(...arg) => onSearch(...arg)}
                      // addModalFields={addModalFields}
                      openApplicationModal={openApplicationModal}
                    />
                  </div>
                  {!!tableData.length && (
                    <AppTable
                      data={tableData}
                      columns={columns}
                      onChange={(...arg) => onPageChange(...arg)}
                      total={rowcount}
                      reorder={true}
                      editAction={(...args) => editConnectorLead(...args)}
                      viewAction={(...args) => viewConnectorLead(...args)}
                      editable={adminPersona ? false : true}
                      deletable={adminPersona ? false : false}
                      deleteAction={(...args) => deleteConnectorLead(...args)}
                      loading={isFetching}
                      rowSelection={adminPersona ? "" : rowSelection}
                      checkbox={adminPersona ? false : true}
                      isCustomRowKey={true}
                      customRowKey={"connector_lead_id"}
                    ></AppTable>
                  )}
                  {tableData.length == 0 && (
                    <div className="empty_layout"></div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {!notSelected && (
            <div className="row bottom_container">
              <div className="col-12 text-end">
                <button
                  className="btn btn-primary m-3"
                  onClick={(e) => handleSendPayout(e)}
                >
                  Send for Payout
                </button>
              </div>
            </div>
          )}
          {/* below button hidden on UI */}
          <button
            className="btn btn-sm btn-outline-secondary d-none"
            onClick={(e) => addChangepasswordData(e)}
            ref={payoutModalRef}
            data-bs-toggle="modal"
            data-bs-target="#sendPayoutModal"
          >
            <span>Change Password</span>
          </button>
        </div>
      ) : (
        <></>
      )}

      <AppFormModal
        // form={modalState.appform}
        form={appform}
        title={modalState.title}
        open={modalState.open}
        onValuesChange={handleValuesChange}
        onClose={closeModal}
        fields={modalState.fields}
        onSubmit={handleAppModalSubmit}
        mode={modalState.mode}
      />

      <OfflineModal
        id="applicationCanvas"
        title={`${
          editmode ? "Edit Lead" : viewmode ? "View Lead" : "Add Lead"
        }`}
        show={openCanvas}
        onClose={() => onModalClose()}
        data={popupdata}
        editdata={editData}
        fields={popupfields}
        viewmode={viewmode}
        editmode={editmode}
        errorMessage={errorMessage}
        // noValidate={true}
        onSubmit={(...args) => handleSubmit(...args)}
        submitText={`${editmode ? "Update" : "Save & Submit"}`}
        disableallfields={viewmode ? true : false}
      />
      <SendPayoutModal
        id="sendPayoutModal"
        title=""
        submitText="Submit"
        data={payoutdata}
        fields={payoutPopupfields}
        onSubmit={(...args) => handlePayoutSubmit(...args)}
        modaltype="centeredmodal"
        modalSize="default"
        onClose={() => closePayoutModal()}
      />
    </>
  );
};

export default constore(Enquiries);
